import { render, staticRenderFns } from "./panelWeek.vue?vue&type=template&id=1853f83d&scoped=true"
import script from "./panelWeek.vue?vue&type=script&lang=js"
export * from "./panelWeek.vue?vue&type=script&lang=js"
import style0 from "./panelWeek.vue?vue&type=style&index=0&id=1853f83d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853f83d",
  null
  
)

export default component.exports